module.exports = {
      id: "trending-usage",
      viewBox: "0 0 27.001 27.001",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#trending",
      toString: function () {
        return this.url;
      }
    }